import { Billing, BloomerSourceType, DealType, IBloomies, PaymentTerms } from './domain';
import { DeepPartial } from './partial';
import { IContact, IBloomer, IAccountManager, ISociety, IPricing, IMission, Invitation } from './types.shared';

export interface BloomerATS {
  firstname: string;
  lastname: string;
  email: string;
  phoneNumber?: string;
  accountManagerName?: string;
  accountManager: IAccountManager[];
  hiresweetContactId: string;
}

export interface InvitePricingPayload {
  startDate: string;
  purchasePricePerDayWithoutTaxes: number;
  salePricePerDayWithoutTaxes: number;
  astreinteCoef: number;
  taxes: number;
  paymentTerms: PaymentTerms;
  paymentTermsDetails?: string;
}

export type InviteSocietyPayload = {
  name: string;
  siret: string;
  externalId: string;
  addressCountryCode: string;
} & Partial<{
  status: string;
  tva: string;
  addressZip: string;
  addressTown: string;
  addressCountry: string;
  isClient: boolean;
  addressPart1: string;
  addressName: string;
}>;

export interface InviteContactPayload extends IContact {
  nameJob: string;
  firstname: string;
  lastname: string;
  email: string;
  phoneNumber?: string;
  externalId: string;
  isBilling: boolean;
}

export enum ContractType {
  bloomaysContract = 'bloomaysContract',
  clientContract = 'clientContract',
  devis = 'devis',
  BDC = 'BDC',
}

export type Recruiters = {
  buteur: IBloomies;
  defenseur: IBloomies;
  capitaine: IBloomies;
  passeur: IBloomies;
};

export type Deal = {
  // TODO rename in WIN
  label: string;
  jobTitle: string;
  beginMission: string;
  endMission: string;
  type: DealType;
  externalId: string;
  context?: string;
  leadOrigin: string;
  leadCanal: string;
  bloomerSource: BloomerSourceType;
  externalUrl: string;
  enableCRAUpload: boolean;
  bloomerInPortage: boolean;
  missionAddress: string;
  contractType: ContractType;
  additionnalNotes?: string;
  accountManager: IBloomies[];
  recruiters: Recruiters;
  clientPaydateDays?: number;
  bloomerPaydateDays?: number;
  replacement?: boolean;
  relatedObjects: {
    clientSocietyId: string;
    clientBillingSocietyId: string;
    candidateCardId: string;
    contactOperationsId: string;
    purchasePricePerDayWithoutTaxes: number;
    salePricePerDayWithoutTaxes: number;
    clientBillingContactId?: string;
    legalContactId?: string;
  };
};

export type DealPayload = Omit<Deal, 'relatedObjects'> & {
  bloomer: BloomerATS;
  clientSociety: InviteSocietyPayload;
  contactOperations: IContact;
  clientBillingSociety: InviteSocietyPayload;
  clientBillingContact: IContact;
  pricing: InvitePricingPayload;
  legalContact?: IContact;
  hubspotClientSocietyId?: string;
};

export type PartialDealPayload = DeepPartial<DealPayload>;

export type UpsertWonFreelanceDealResult = {
  mission: IMission;
  bloomer: IBloomer;
  tops: IAccountManager;
  invitation?: Invitation;
  clientSociety: ISociety;
  clientBillingSociety: ISociety;
  contactOperations: IContact;
  pricing: IPricing;
};

export type UpsertCDIFreelanceDealResult = {
  billings: Billing[];
  clientSociety: ISociety;
  clientBillingContact: IContact;
  bloomer: IBloomer;
  beginDate: string;
};

export enum DealStage {
  jobs_ouverts = 'jobs_ouverts',
  sourcing_started = 'sourcing_started',
  cv_sent = 'cv_sent',
  job_win = 'job_win',
  job_lost = 'job_lost',
}
